module.exports = __webpack_public_path__ + "img/cs-bottom-image.d062a303.svg";